import AccountSettingsForm from './AccountSettingsForm';

export default AccountSettingsForm;
export type { AccountSettingsFormProps } from './AccountSettingsForm';
